import { render, staticRenderFns } from "./AssignGeneralEffects.vue?vue&type=template&id=beb2ae1a&"
import script from "./AssignGeneralEffects.vue?vue&type=script&lang=js&"
export * from "./AssignGeneralEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports